export default "__VITE_ASSET__9fe68e80__"